/* eslint-disable no-console,global-require,import/no-extraneous-dependencies */
import '@eti/validation';
import '@eti/travelers';
import '@eti/debug';
import '@eti/utils';
import * as Sentry from '@sentry/react';
import './common/debug/components/DebugSiteProperties';
import './widgets/search-form/containers/SearchFormContainer';

import ReactDOM from 'react-dom';
import App from './main/components/App';
import suppressConsoleWarnings from './utils/suppressConsoleWarnings';
import { isDev } from './common/debug/utils';

if (window.spa_variables?.properties?.['IbeClient.SentrySDK.Enabled'] ?? false) {
  const getEnvironment = () => {
    if (isDev) {
      return 'development';
    }

    return window.location.host.includes('ibetest.etgcloud.io') ? 'test' : 'production';
  };

  const getRedactedUrl = (urlString) => {
    try {
      const url = new URL(urlString);

      url.searchParams.forEach((value, key) => {
        url.searchParams.set(key, '[REDACTED]');
      });

      return url.toString();
    } catch {
      return urlString;
    }
  };

  Sentry.init({
    dsn: window.spa_variables?.properties?.['IbeClient.SentrySDK.DSN'] ?? '',
    sendDefaultPii: false,
    environment: getEnvironment(),
    integrations: [
      Sentry.captureConsoleIntegration({
        levels: ['error', 'warn'],
      }),
      Sentry.graphqlClientIntegration({
        endpoints: [/^\/graphql\//gi],
      }),
    ],
    sampleRate: 0.25,
    beforeBreadcrumb: (breadcrumb) => {
      if (breadcrumb.category === 'fetch' && breadcrumb.data?.url?.startsWith('/ibemgr')) {
        return null;
      }

      if (breadcrumb.category === 'navigation') {
        return {
          ...breadcrumb,
          data: {
            ...breadcrumb.data,
            from: getRedactedUrl(breadcrumb.data.from),
            to: getRedactedUrl(breadcrumb.data.to),
          },
        };
      }

      return breadcrumb;
    },
    beforeSend: (event) => {
      return {
        ...event,
        request: {
          ...event.request,
          url: getRedactedUrl(event.request.url),
        },
      };
    },
  });
}

(async () => {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
})();

if (process.env.NODE_ENV === 'development') {
  suppressConsoleWarnings();
}

ReactDOM.render(<App />, document.getElementById('root'));
